import OrderMatterportApi from '../OrderMatterportApi';

export function sendLink({ orderId, link }): Promise<string> {
    return OrderMatterportApi.setMatterportLink(orderId, link);
}

export function getLink(orderId) {
    return OrderMatterportApi.getMatterportLink(orderId);
}
